import React from "react";

const InquiryHistory = () => {
  return <div>Inquiry Page Coming Soon</div>;
};

export default InquiryHistory;
